module.exports = __webpack_public_path__ + "img/registration.1d69f475.svg";